import React from 'react';
import { Box } from '@mui/material';
import { buildImageSources } from './yovoImageSources';

/**
 * One img for destination cards and campaign banners.
 * Lazy by default. Renders a grey box instead of src="".
 */
class YovoImage extends React.Component {
  render() {
    const {
      src,
      alt = '',
      width,
      height,
      eager = false,
      sizes,
      srcSet,
      sx,
      className,
    } = this.props;

    const sources = buildImageSources(src, sizes);
    const resolvedSrc = sources.src;
    const resolvedSrcSet = srcSet || sources.srcSet;
    const resolvedSizes = sizes || sources.sizes;

    if (!resolvedSrc) {
      return (
        <Box
          className={className}
          aria-hidden="true"
          sx={{
            bgcolor: '#E8E9ED',
            width: width || '100%',
            height: height || '100%',
            ...sx,
          }}
        />
      );
    }

    return (
      <Box className={className} sx={sx}>
        <img
          src={resolvedSrc}
          alt={alt}
          width={width}
          height={height}
          decoding="async"
          loading={eager ? 'eager' : 'lazy'}
          srcSet={resolvedSrcSet}
          sizes={resolvedSizes}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            display: 'block',
            transition: 'transform 0.3s ease',
          }}
        />
      </Box>
    );
  }
}

export default YovoImage;
